<template>
  <div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              :options='actions'
              @handleAction="handleAction"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllCommandeSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-5 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeCommandes.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeCommandes.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
              :perm="permCommandes.exporter"
              :query="exportExcelQuery"/>
        </div>
      </div>
    </div>
    <v-server-table url=""
                    :columns="columns"
                    :options="options"
                    @loaded="finLoading"
                    @loading="debutLoading"
                    class="overflow-x-auto"
                    ref="tablelisteCommandesCommissions">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tablelisteCommandesCommissions.setLimit($event)" />
      </template>
      <template slot="child_row" slot-scope="props">
        <recapitulatif-commissions-lignes-commande
          :lignesCommandeCommissions="getLigneOfCommissionsCommande(props.row)"
          :lignes-commande="props.row.lignesCommande">
        </recapitulatif-commissions-lignes-commande>
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="commandes">
        </table-footer-totaux>
      </template>
      <div slot="selected" slot-scope="props">
        <qd-checkbox v-model="props.row.selected"></qd-checkbox>
      </div>
      <div slot="commissionEtat" slot-scope="props">
        {{ $t(getEtatTraduction(props.row.commissionEtat)) }}
      </div>
      <div slot="datePremierAffichage" slot-scope="props"
           :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        {{props.row.datePremierAffichage | formatDate}}
      </div>
      <div slot="typeReferenceExterne" slot-scope="props" :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos }">
        {{ props.row.typeReferenceExterne === encaissement
        ? $t('listeCommandeCommissions.table.encaissement')
        : $t('listeCommandeCommissions.table.avance')}}
      </div>
      <div slot="dateDevisCommande" slot-scope="props"
           :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        <span v-if="props.row.dateDevisCommande">
          {{props.row.dateDevisCommande | formatDate}}
        </span>
      </div>
      <div slot="planMedia" slot-scope="props">
        <router-link-blank
            v-if="props.row.planMedia && props.row.planMediaId"
            :message="props.row.planMedia.code"
            :to="{
              name: 'c.presse.plan_media',
              params: {   id: props.row.planMediaId }
              }">
        </router-link-blank>
      </div>
      <div slot="remiseBancaireExterne" slot-scope="props">
        <router-link-blank
            v-if="props.row.remiseBancaireExterne"
            :message="$t('listeCommandeCommissions.table.remiseBancaire',
                      { code: props.row.remiseBancaireExterne.num })"
            :to="{
              name: 'c.bodac.remises_bancaires',
              params: {   id: props.row.remiseBancaireExterne.id }
              }">
        </router-link-blank>
      </div>
      <div slot="commandeVenteExterne" slot-scope="props">
        <router-link-blank
            v-if="props.row.commandeVenteExterne"
            :message="props.row.commandeVenteExterne.code"
            :to="{
              name: 'c.bodac.commandes',
              params: {   id: props.row.commandeVenteExterne.id }
              }">
        </router-link-blank>
      </div>
      <div slot="factureVenteExterne" slot-scope="props">
        <router-link-blank
            v-if="props.row.factureVenteExterne"
            :message="props.row.factureVenteExterne.code"
            :to="{
              name: 'c.bodac.factures',
              params: {   id: props.row.factureVenteExterne.id }
              }">
        </router-link-blank>
      </div>
      <div slot="listeIntervenants" slot-scope="props"
           :class="{ 'textDecorationLineThrough':
             props.row.etat === sansSuite || props.row.etat === clos }">
        {{props.row.listeIntervenants}}
      </div>
      <div slot="montantTtc" slot-scope="props" class="is-pulled-right"
           :class="{ 'textDecorationLineThrough':
             props.row.etat === sansSuite || props.row.etat === clos }">
        {{props.row.montantTtc | formatDevise}}
      </div>
      <div slot="history" slot-scope="props" class="has-text-centered">
        <div
          :class="{'disabled': props.row.sousType === SOUS_TYPE_AVOIR
            || props.row.sousType === SOUS_TYPE_AVOIR_SUR_ACOMPTE }"
          @click="viewHistoryCommande(props.row)"
          class="is-cursor-pointer">
          <b-icon icon="history" type="is-primary" class="mgt-7px">
          </b-icon>
        </div>
      </div>
      <template v-slot:societe="props">
        {{ getSocieteLibelle(props.row.societeId) }}
      </template>
      <div slot="facturer" slot-scope="props" class="is-pulled-right">
        <div :class="{'disabled':
              !estValidable(props.row)
              || !checkPermissions(permCommandes.maj),
             'button-access-no-permission': !checkPermissions(permCommandes.maj)}"
             @click="openPopUpPreventionFacturation(props.row)">
          <div class="button is-addOrEdit "
          :class="{'button-access-no-permission': !checkPermissions(permCommandes.maj)}">
              <span>
                {{ $t('listeCommandeCommissions.table.actions.facturer') }}
              </span>
          </div>
        </div>
      </div>
      <div slot="enregistrer" slot-scope="props" class="is-pulled-right">
        <div
          class="button is-addOrEdit" @click="openPopUpPreventionEnregistrement(props.row)"
          :class="{'disabled':
            !estVersable(props.row)
            || !checkPermissions(permCommandes.maj),
             'button-access-no-permission': !checkPermissions(permCommandes.maj)}">
          <span>
            {{ $t('listeCommandeCommissions.table.actions.enregistrer') }}
          </span>
        </div>
      </div>
      <div slot="annuler" slot-scope="props" class="is-pulled-right">
        <div class="button is-addOrEdit mgl-5px" @click="openPopUpPreventionAnnulation(props.row)"
             :class="{'disabled':
             !estAnnulable(props.row)
             || !checkPermissions(permCommandes.maj),
             'button-access-no-permission': !checkPermissions(permCommandes.maj)}"
              >
          <span>
            {{ $t('listeCommandeCommissions.table.actions.annuler') }}
          </span>
        </div>
      </div>
    </v-server-table>
    <b-modal v-model="popUpPreventionAnnulation" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('listeCommandeCommissions.actions.annulation.title')"
        :mess-footer="$t('listeCommandeCommissions.actions.annulation.footer')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        :messagesPopup="messageErreur"
        :isErrorPopup="error"
        @no="popUpPreventionAnnulation = false"
        @yes="annulerFacturationCommande(commandeSelected.id)">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpPreventionFacturation" has-modal-card class="modal">
      <pop-up-prevention :mess-header="$t('listeCommandeCommissions.actions.facturation')"
                         mess-footer=""
                         :cancel="$t('general.button.cancel')"
                         :validate="$t('general.button.next')"
                         @no="popUpPreventionFacturation = false"
                         @yes="facturationCommandeCommission(
                           commandeSelected.echeanciers,
                           commandeSelected.typeReferenceExterne,
                           commandeSelected.referenceExterne,
                           commandeSelected.referenceExterne1Id,
                           commandeSelected.referenceExterne2Id,
                           commandeSelected.referenceExterne3Id,
                           false)">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpPreventionEnregistrement" has-modal-card class="modal">
      <pop-up-prevention :mess-header="$t('listeCommandeCommissions.actions.enregistrement.title')"
                         :mess-footer="$t('listeCommandeCommissions.actions.enregistrement.footer')"
                         :cancel="$t('general.button.cancel')"
                         :validate="$t('general.button.next')"
                         @no="popUpPreventionEnregistrement = false"
                         @yes="enregistrementFactureCommissions()">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpHistory" has-modal-card class="modal">
      <history-commande-commission :commande="commandeSelected"
      :isForCommericaux="true"></history-commande-commission>
    </b-modal>
    <b-modal v-model="popUpChangeDates" has-modal-card class="modal">
      <div class="card pd-20px">
        <div class="card-content">
          <p class="title mgb-40px">
            {{ $t('listeCommandeCommissions.actions.changeDate.title') }}
          </p>
          <b-field class="mgb-40px"
            :label="$t('listeCommandeCommissions.actions.changeDate.label')">
            <b-datepicker show-week-number
                    nearby-selectable-month-days
                    v-model="newDateForChange"
                    icon="calendar-today"
                    :editable="true">
            </b-datepicker>
          </b-field>
          <button class="button btn-modal-annuler is-cancel has-text-centered mg-button-modal"
                  @click="popUpChangeDates = false">
            {{ $t('general.button.cancel') }}
          </button>
          <button
            class="button is-warning has-text-centered mg-button-modal"
            @click="changesDates()">
            {{ $t('general.button.apply') }}
          </button>
        </div>
      </div>
    </b-modal>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-commande-commissions
          v-model="critereRecherche"
          ref="filtreListeCommandeCommissions"
          :afficherFiltreCommercial="!commercialId"
          :afficherDate="true"
          :inCommande="isCommande"
          :inFacture="isFacture"
          :disabledDateFin="$route.name === 'c.presse.mois_comptable'"
          @toggleFiltre="changeValueShowFiltreAndLockMenu()"
          @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { createNamespacedHelpers } from 'vuex';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import * as devisConf from '@/configuration/devisConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import recapitulatifCommissionsLignesCommande
  from '@/components/devisCommandes/detailDevisCommande/recapitulatifCommissionsLignesCommande';
import {
  TYPE_REFERENCE_EXTERNE_COMMANDE_VENTE_AVANCE,
  TYPE_REFERENCE_EXTERNE_LETTRAGE_A_PAIEMENT,
  ALL_ETAT_COMMISSION,
  A_VALIDER,
  A_VERSER,
  VERSEE,
  EXPORT_EXCEL_COMMISSION,
  EXPORT_EXCEL_TYPE_VENDEUR,
} from '@/configuration/dcf/dcfConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageErreur from '@/services/general/messageErreur';
import {
  annulerAllFacturationCommandes,
  annulerFacturationCommandes, brouillon2Facture, brouillon2FactureAll,
  factureGeneration as factureGenerationAchat,
} from '@/api/factureAchat';
import formatDate from '@/services/general/formatIsoDate';
import { SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE } from '@/configuration/facture/factureConf';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import selecteurAction from '@/components/general/selecteurAction';
import filtreListeCommandeCommissions
  from '@/components/commande/commissions/filtreListeCommandeCommissions';
import cloneDeep from 'lodash/cloneDeep';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import { columnsSplice } from '@/services/general/columns';
import validationAnnulationCommission from '@/services/devisCommandes/validation/validationAnnulationCommission';
import historyCommandeCommission from '@/components/commissions/historyCommandeCommission';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { UpdateDateCommissionAsync } from '@/api/commissionVendeur/index';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import transformerCommissions from '@/services/commissions/transformerCommissions';
import {
  ACTION_ANNULATION,
  ACTION_ENREGISTREMENT,
  ACTION_FACTURATION,
  ACTION_CHANGE_DATE,
} from '@/configuration/commande/commandeConf';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Societe = createNamespacedHelpers('societe');
const CommandeAchat = createNamespacedHelpers('commandeAchat');
const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'commissionsCommande',
  components: {
    TableItemsInView,
    recapitulatifCommissionsLignesCommande,
    popUpPrevention,
    filtreListeCommandeCommissions,
    selecteurAction,
    historyCommandeCommission,
    routerLinkBlank,
    tableFooterTotaux,
    exportExcelButton,
  },
  props: {
    dcf: {
      type: Object,
      required: false,
    },
    dates: {
      type: Object,
      required: false,
    },
    commercialId: {
      required: false,
    },
    disableActions: {
      type: Boolean,
      required: false,
    },
    dateNow: {
      type: Date,
      required: false,
    },
  },
  data() {
    return {
      commandeSelected: null,
      permCommandes: COMMANDES,
      sansSuite: devisConf.ETAT_SANSSUITE,
      clos: devisConf.ETAT_CLOTURER,
      enregistrer: devisConf.ETAT_ENREGISTRE,
      facturer: devisConf.ETAT_FACTURE,
      popUpPreventionAnnulation: false,
      popUpPreventionFacturation: false,
      popUpHistory: false,
      popUpPreventionEnregistrement: false,
      popUpChangeDates: false,
      avance: TYPE_REFERENCE_EXTERNE_COMMANDE_VENTE_AVANCE,
      encaissement: TYPE_REFERENCE_EXTERNE_LETTRAGE_A_PAIEMENT,
      showFiltre: false,
      SOUS_TYPE_AVOIR,
      SOUS_TYPE_AVOIR_SUR_ACOMPTE,
      actions: [
        { action: ACTION_FACTURATION, translation: 'listeCommandeCommissions.actionsMass.facturation' },
        { action: ACTION_ENREGISTREMENT, translation: 'listeCommandeCommissions.actionsMass.enregistrer' },
        { action: ACTION_ANNULATION, translation: 'listeCommandeCommissions.actionsMass.annulation' },
        { action: ACTION_CHANGE_DATE, translation: 'listeCommandeCommissions.actionsMass.changeDate' },
      ],
      displayCommandesAnt: false,
      messageErreur: [],
      error: false,
      newDateForChange: new Date(),
      A_VALIDER,
      A_VERSER,
      VERSEE,
    };
  },
  methods: {
    ...CommandeAchat.mapActions({
      actionsLoadCommandes: 'loadCommandesAchat',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    estAnnulable(commission) {
      return [this.VERSEE, this.A_VERSER].includes(commission.commissionEtat);
    },
    estValidable(commission) {
      return [A_VALIDER].includes(commission.commissionEtat);
    },
    estVersable(commission) {
      return [A_VERSER].includes(commission.commissionEtat);
    },
    getSocieteLibelle(societeId) {
      return this.societesInformations.find(s => s.id === societeId)?.libelle ?? '';
    },
    async changesDates() {
      const dateAndCommissions = {
        commissionsIds: this.commandes.filter(c => c.selected).map(c => c.id),
        dateCommission: formatDate(this.newDateForChange),
      };
      const loadingComponent = this.$buefy.loading.open();
      try {
        await UpdateDateCommissionAsync(dateAndCommissions);
        this.newDateForChange = new Date();
        this.popUpChangeDates = false;
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getEtatTraduction(etat) {
      return ALL_ETAT_COMMISSION.find(e => e.value === etat)?.libelle ?? '';
    },
    getEcheancierByReferenceExterne(typeReference) {
      const echeancierByReference = [];
      this.getAllCommandeSelected()
        .filter((commande) => commande.typeReferenceExterne === typeReference
          && commande.etat === devisConf.ETAT_ENREGISTRE)
        .forEach((commande) => {
          const refIsAlreadyInArray = echeancierByReference
            .find((el) => {
              return el.referenceExterne === commande.referenceExterne
              && el.referenceExterne1Id === commande.referenceExterne1Id
              && el.referenceExterne2Id === commande.referenceExterne2Id
              && el.referenceExterne3Id === commande.referenceExterne3Id;
            });
          if (refIsAlreadyInArray) {
            refIsAlreadyInArray.echeanciers = refIsAlreadyInArray.echeanciers.concat(
              commande.echeanciers,
            );
          } else {
            echeancierByReference.push({
              echeanciers: commande.echeanciers,
              referenceExterne: commande.referenceExterne,
              referenceExterne1Id: commande.referenceExterne1Id,
              referenceExterne2Id: commande.referenceExterne2Id,
              referenceExterne3Id: commande.referenceExterne3Id,
            });
          }
        });
      return echeancierByReference;
    },
    async deleteAll() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await annulerAllFacturationCommandes({
          ids: this.getAllCommandeSelected().map((el) => el.id),
          dateAvoir: formatDate(new Date()),
        });
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        throw e;
      }
    },
    async makeAllFacturation(echeanciersByReferenceAvance, echeanciersByReferenceEncaissement) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const promises = [];
        echeanciersByReferenceAvance.forEach((ref) => {
          promises.push(this.facturationCommandeCommission(
            ref.echeanciers, this.avance, ref.referenceExterne,
            ref.referenceExterne1Id, ref.referenceExterne2Id, ref.referenceExterne3Id, true,
          ));
        });
        echeanciersByReferenceEncaissement.forEach((ref) => {
          promises.push(this.facturationCommandeCommission(
            ref.echeanciers, this.encaissement, ref.referenceExterne,
            ref.referenceExterne1Id, ref.referenceExterne2Id, ref.referenceExterne3Id, true,
          ));
        });
        await Promise.all(promises);
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        throw e;
      }
    },
    async handleAction(action) {
      switch (action) {
        case ACTION_ENREGISTREMENT:
          await this.enregistrementAllFactureCommissions();
          break;
        case ACTION_FACTURATION:
          await this.makeAllFacturation(
            this.getEcheancierByReferenceExterne(this.avance),
            this.getEcheancierByReferenceExterne(this.encaissement),
          );
          break;
        case ACTION_ANNULATION:
          await this.deleteAll();
          break;
        case ACTION_CHANGE_DATE:
          this.popUpChangeDates = true;
          break;
        default:
          break;
      }
    },
    getAllCommandeSelected() {
      return this.commandes.filter((el) => { return el.selected; });
    },
    selectAll() {
      const select = !this.allCommandeSelected;
      this.commandes.forEach(item => { item.selected = select; });
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeCommandeCommissions.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiser() {
      await this.$refs.filtreListeCommandeCommissions.initializeFiltre();
      this.$refs.filtreListeCommandeCommissions.viderCritere();
      this.$refs.filtreListeCommandeCommissions.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    viewHistoryCommande(commande) {
      this.popUpHistory = true;
      this.commandeSelected = commande;
    },
    getFactureId(commande) {
      let factureId = null;
      commande.echeanciers.forEach((echeancier) => {
        const echeancierLigneWithFacture = echeancier.echeancierLignes.find((echeancierLigne) => {
          return echeancierLigne.factureId !== null;
        });
        if (echeancierLigneWithFacture) factureId = echeancierLigneWithFacture.factureId;
      });
      return factureId;
    },
    async enregistrementAllFactureCommissions() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = this.getAllCommandeSelected().filter(c => this.estVersable(c))
          .map(c => this.getFactureId(c));
        await brouillon2FactureAll(ids);
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async enregistrementFactureCommissions() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await brouillon2Facture({ id: this.getFactureId(this.commandeSelected) });
        this.popUpPreventionEnregistrement = false;
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getFacture(commande) {
      let factureInfo = null;
      commande.echeanciers.forEach((echeancier) => {
        echeancier.echeancierLignes.forEach((echeancierligne) => {
          if (echeancierligne.facture && echeancierligne.facture.code) {
            factureInfo = echeancierligne.facture;
            factureInfo.id = echeancierligne.factureId;
          }
        });
      });
      return factureInfo;
    },
    openPopUpPreventionAnnulation(commande) {
      this.popUpPreventionAnnulation = true;
      this.commandeSelected = commande;
    },
    openPopUpPreventionFacturation(commande) {
      this.popUpPreventionFacturation = true;
      this.commandeSelected = commande;
    },
    openPopUpPreventionEnregistrement(commande) {
      this.popUpPreventionEnregistrement = true;
      this.commandeSelected = commande;
    },
    async annulerFacturationCommande(id) {
      this.messageErreur = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await annulerFacturationCommandes({
          id: id,
          dateAvoir: formatDate(new Date()),
        });
        this.popUpPreventionAnnulation = false;
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e?.response?.data?.error) {
          validationAnnulationCommission(e.response, this.messageErreur);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    initialiseListeEcheancePayeurs(echeanciers) {
      const echeancePayeurLigne = [];
      echeanciers.forEach(echeancier => {
        echeancier.echeancierLignes
          .filter(ligneEcheance => ligneEcheance.factureId === null
            && !ligneEcheance.facturationFaite)
          .forEach(ligne => {
            const echeance = {
              id: ligne.id,
            };
            echeancePayeurLigne.push(echeance);
          });
      });
      return echeancePayeurLigne.sort(this.compareEcheance);
    },
    async facturationCommandeCommission(echeanciers, typeReferenceExterne, referenceExterne,
      referenceExterne1Id, referenceExterne2Id, referenceExterne3Id, isMulti) {
      let loadingComponent;
      if (!isMulti) loadingComponent = this.$buefy.loading.open();
      try {
        const echeances = this.initialiseListeEcheancePayeurs(echeanciers);
        await factureGenerationAchat({
          listeEcheancierLigneId: echeances.map((ech) => ech.id),
          dateFacturation: formatDate(new Date()),
          calculeEnQuantite: true,
          genererFactureZero: true,
          enregistrerFactures: false,
          typeReferenceExterne: typeReferenceExterne,
          referenceExterne: referenceExterne,
          referenceExterne1Id: referenceExterne1Id,
          referenceExterne2Id: referenceExterne2Id,
          referenceExterne3Id: referenceExterne3Id,
        });
        this.popUpPreventionFacturation = false;
        if (!isMulti) this.recherche();
        if (!isMulti) loadingComponent.close();
      } catch (e) {
        if (!isMulti) loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getLigneOfCommissionsCommande(commande) {
      return commande.lignesCommande.filter((ligneCommande) => {
        return ligneCommande.type === devisConf.NORMAL;
      });
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    recherche() {
      this.$refs.tablelisteCommandesCommissions.refresh();
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
    }),
    ...CommandeAchat.mapGetters({
      commandes: 'commandes',
      lastDataFromLoad: 'lastDataFromLoad',
      totalCommandes: 'totalCommandes',
      critereRecherche: 'criteresRecherche',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_COMMISSION,
        typeExport: EXPORT_EXCEL_TYPE_VENDEUR,
        filtres: transformerCommissions(this.lastDataFromLoad),
      };
    },
    allCommandeSelected() {
      return this.getAllCommandeSelected().length === this.commandes.length
        && this.commandes.length > 0;
    },
    multiSociete() {
      return this.societesInformations.length > 1;
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    columns() {
      const columns = ['selected', 'dateDevisCommande', 'listeIntervenants', 'commissionEtat', 'remiseBancaireExterne', 'planMedia', 'commandeVenteExterne', 'factureVenteExterne', 'typeReferenceExterne', 'montantTtc', 'societe', 'facturer', 'enregistrer', 'annuler', 'history'];
      if (this.disableActions) {
        columnsSplice(columns, 'facturer');
        columnsSplice(columns, 'enregistrer');
        columnsSplice(columns, 'annuler');
      }
      if (!this.multiSociete) {
        columnsSplice(columns, 'societe');
      }
      if (!this.modulePlanMediaActive) {
        columnsSplice(columns, 'planMedia');
      }
      return columns;
    },
    nombreCritere() {
      const banCritere = ['auto', 'dates'];
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.dates
      && (this.critereRecherche.dates.dateDebut || this.critereRecherche.dates.dateFin)) {
        nbCritere += 1;
      }
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    iconSelectTotal() {
      if (this.allCommandeSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    targetTotal() {
      return ['montantTtc'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          remiseBancaireExterne: this.$i18n.t('listeCommandeCommissions.table.remiseBancaireExterne'),
          dateDevisCommande: this.$i18n.t('listeCommandeCommissions.table.dateDevisCommande'),
          listeIntervenants: this.$i18n.t('listeCommandeCommissions.table.listeIntervenants'),
          montantTtc: this.$i18n.t('listeCommandeCommissions.table.montantCommission'),
          typeReferenceExterne: this.$i18n.t('listeCommandeCommissions.table.typeReferenceExterne'),
          commissionEtat: this.$i18n.t('listeCommandeCommissions.table.referenceEtat'),
          planMedia: this.$i18n.t('listeCommandeCommissions.table.planMedia'),
          commandeVenteExterne: this.$i18n.t('listeCommandeCommissions.table.commande'),
          factureVenteExterne: this.$i18n.t('listeCommandeCommissions.table.facture'),
          societe: this.$i18n.t('listeCommandeCommissions.table.societe'),
          facturer: '',
          enregistrer: '',
          annuler: '',
          history: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: ['dateDevisCommande', 'listeIntervenants', 'commissionEtat', 'remiseBancaireExterne', 'planMedia', 'commandeVenteExterne', 'factureVenteExterne', 'typeReferenceExterne', 'montantTtc'],
        columnsClasses: {
          listeIntervenants: 'ellipsis colonneListeIntervenants',
          facturer: 'width-100',
          enregistrer: 'width-205px',
          annuler: 'width-190px',
          selected: 'colonneSelected',
        },
        requestFunction: ((data) => {
          this.critereRecherche.dates = this.dates ?? this.critereRecherche.dates;
          if (!data.query) data.query = cloneDeep(this.critereRecherche);
          data.query.type = devisConf.TYPE_COMMANDE;
          if (!data.query.typesReferenceExterne?.length > 0) {
            data.query.typesReferenceExterne = [
              TYPE_REFERENCE_EXTERNE_LETTRAGE_A_PAIEMENT,
              TYPE_REFERENCE_EXTERNE_COMMANDE_VENTE_AVANCE];
          }
          if (data.query.dates && (data.query.dates.dateDebut || data.query.dates.dateFin)) {
            data.query.dates.dateDebut = formatDate(data.query.dates.dateDebut);
            data.query.dates.dateFin = formatDate(data.query.dates.dateFin);
          }
          if (this.commercialId) {
            data.query.commercialId = [this.commercialId];
          }
          data.query.commissionEtat = tagInputToArray(this.critereRecherche.commissionEtat, 'value');
          data.query.planMediaIds = tagInputToArray(this.critereRecherche.planMediaIds, 'id');
          if (this.dcf) {
            if (this.isFacture) {
              this.critereRecherche.referencesExternesFacturesIds = [this.dcf];
            } else if (this.isCommande) {
              this.critereRecherche.referencesExternesCommandesIds = [this.dcf];
            }
          }
          data.query.referencesExternesCommandesIds = tagInputToArray(this.critereRecherche.referencesExternesCommandesIds, 'id');
          data.query.referencesExternesFacturesIds = tagInputToArray(this.critereRecherche.referencesExternesFacturesIds, 'id');
          data.query.remisesBancairesIds = tagInputToArray(this.critereRecherche.remisesBancairesIds, 'id');
          return this.actionsLoadCommandes(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.commandes,
            count: this.totalCommandes,
          };
        }),
      };
    },
    isFacture() {
      return this.dcf?.type === devisConf.TYPE_FACTURE;
    },
    isCommande() {
      return this.dcf?.type === devisConf.TYPE_COMMANDE;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePlanMedia.key]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
